import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { lenderResourceShareService } from "@/modules/contacts/features/lender/store/resource-share-services/lender-resource-share-service";
import { RESOURCE_SHARE_RELATED_TAGS } from "@/modules/contacts/features/lender/utils/resource-share-service-tags";

const createResourceShare = lenderResourceShareService.injectEndpoints({
  endpoints: builder => ({
    createResourceShare: builder.mutation({
      query: ({ lenderId, uploadIds }) => ({
        url: `lenders/${lenderId}/resource-shares`,
        method: "POST",
        body: { uploadIds },
      }),
      invalidatesTags: RESOURCE_SHARE_RELATED_TAGS,
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          data.map(resourceShare => {
            sendAnalytics(ANALYTIC_EVENTS.RESOURCE_SHARE_CREATED, resourceShare);
            return resourceShare;
          });

          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Resource has been shared successfully!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useCreateResourceShareMutation } = createResourceShare;

